import { validarSintaxis } from './validarSintaxis'
import { normalizaAlias } from './normalizaAlias'
import { parseExpression, normalizeNode, stringifyNode } from '../motor/ast'

/**
 * Normaliza todos los placeholders detectados y devuelve:
 * - lista normalizada
 * - errores detectados
 * - mapa expresiones finales por tag original
 */
export function normalizarPlaceholders(placeholders, variables, expresiones, errors = []) {
  const { aliasToVariable, aliasToExpresion, pathToVariable } = normalizaAlias(variables, expresiones)

  const resultados = []
  const errores = []
  const mapaFinal = {} // tagOriginal → expresionFinal

  for (const ph of placeholders) {
    const tag = ph.tag
    const contenido = ph.contenido.trim()

    // Validación inicial de sintaxis (básica)
    const sint = validarSintaxis(tag)
    if (!sint.ok) {
      errores.push({ tag, error: sint.error })
      mapaFinal[tag] = tag
      continue
    }

    const ast = parseExpression(tag, errors)
    const norm = normalizeNode(ast, aliasToVariable, aliasToExpresion, pathToVariable, errors)
    const normalizado = stringifyNode(norm)

    mapaFinal[tag] = `\${${normalizado}}`
    resultados.push({ original: tag, normalizado: mapaFinal[tag], tipo: 'normalizado' })
  }

  return {
    resultados,
    errores,
    mapaFinal,
  }
}
